module.exports = __webpack_public_path__ + "img/shopify.3f0d952e.svg";